import {
  type CoachmarkAlign,
  type CoachmarkBoxOffset,
  type CoachmarkSide,
} from './CoachmarkTooltip';
import { type BuildProFeatureCoachmarkFeature } from './types';

export const COACHMARK_IMAGE_LOCALES = ['ko', 'en', 'ja', 'id', 'th'] as const;

type CoachmarkImageLocale = (typeof COACHMARK_IMAGE_LOCALES)[number];

type CoachmarkDescriptionKey =
  | 'build:coachmark.aiTutor.description'
  | 'build:coachmark.aiTranslation.description'
  | 'build:coachmark.nextQuizset.description'
  | 'build:coachmark.hideFromLibrary.description';

export const resolveCoachmarkLocale = (locale: string): CoachmarkImageLocale =>
  (COACHMARK_IMAGE_LOCALES as readonly string[]).includes(locale)
    ? (locale as CoachmarkImageLocale)
    : 'en';

export const BUILD_PRO_FEATURE_COACHMARK_CONFIG: Record<
  BuildProFeatureCoachmarkFeature,
  { descriptionKey: CoachmarkDescriptionKey; imageName: string }
> = {
  AI_TUTOR: {
    descriptionKey: 'build:coachmark.aiTutor.description',
    imageName: 'ai-tutor',
  },
  AI_QUIZSET_TRANSLATION: {
    descriptionKey: 'build:coachmark.aiTranslation.description',
    imageName: 'ai-translation',
  },
  CONTINUE_NEXT_QUIZSET: {
    descriptionKey: 'build:coachmark.nextQuizset.description',
    imageName: 'next-quizset',
  },
  PRIVATE_QUIZ: {
    descriptionKey: 'build:coachmark.hideFromLibrary.description',
    imageName: 'hide-from-library',
  },
};

type CoachmarkPlacement = {
  side: CoachmarkSide;
  align: CoachmarkAlign;
};

const COACHMARK_DESIGN_GAP = 8;
const COACHMARK_TOGGLE_ARROW_OFFSET = 12;
const COACHMARK_SETTING_CONTAINER_PADDING = 32;

export const COACHMARK_BOX_OFFSET = {
  topBottom: COACHMARK_DESIGN_GAP + COACHMARK_TOGGLE_ARROW_OFFSET,
  leftRight:
    COACHMARK_SETTING_CONTAINER_PADDING +
    COACHMARK_DESIGN_GAP +
    COACHMARK_TOGGLE_ARROW_OFFSET,
} satisfies CoachmarkBoxOffset;

export const COACHMARK_PLACEMENT: Record<
  BuildProFeatureCoachmarkFeature,
  { pc: CoachmarkPlacement; tablet: CoachmarkPlacement }
> = {
  AI_TUTOR: {
    pc: { side: 'right', align: 'center' },
    tablet: { side: 'bottom', align: 'end' },
  },
  AI_QUIZSET_TRANSLATION: {
    pc: { side: 'right', align: 'center' },
    tablet: { side: 'bottom', align: 'end' },
  },
  CONTINUE_NEXT_QUIZSET: {
    pc: { side: 'right', align: 'center' },
    tablet: { side: 'top', align: 'end' },
  },
  PRIVATE_QUIZ: {
    pc: { side: 'right', align: 'end' },
    tablet: { side: 'top', align: 'end' },
  },
};
